import { getPostBySlug } from '$lib/posts';
import { handleAlert } from '$lib/components/alert';
import type { PageLoad } from './$types';

export const load: PageLoad = async ({ params }) => {
	try {
		const { data, error } = await getPostBySlug(params.slug);

		if (error) {
			handleAlert({ type: 'error', text: error.message });
			return {
				post: null,
				validated: false
			};
		}

		const validated = data?.type === 'action' && data?.actionvalidated === true;

		const post = data;

		return {
			post,
			validated
		};
	} catch (error) {
		console.error('Error loading post:', error);
		handleAlert({ type: 'error', text: error.message });
		return {
			post: null,
			validated: false
		};
	}
};
